import React from 'react';
import PropTypes from 'prop-types';
import { useMouseCoordinates } from '../MouseCoordinatesWrapper';
import { Body4 } from '../../../../../../atomic/text/Text';
import style from './HoverBox.module.css';
import ReactDOM from 'react-dom';

export const HoverBox = ({
  json,
  topBoundary,
  bottomBoundary,
  leftBoundary,
  rightBoundary,
  portalRef,
  size,
}) => {
  const { coordinates, showCrossHairs } = useMouseCoordinates();
  const [x, y] = coordinates;
  if (!portalRef || !portalRef.current) return null;

  return ReactDOM.createPortal(
    <>
      {x > leftBoundary &&
      x < rightBoundary &&
      y > topBoundary &&
      y < bottomBoundary &&
      showCrossHairs ? (
          <foreignObject
            id="hoverBox"
            x={x > size / 2 ? x - 120 : x}
            y={y > size / 2 ? y - 80 : y}
            width={120}
            height={200}
          >
            <div className={style.box}>
              {Object.entries(json).map((entry) => {
                return <Body4 key={entry[0]}>{`${entry[0]}: ${entry[1]}`}</Body4>;
              })}
            </div>
          </foreignObject>
        ) : null}
    </>,
    portalRef.current
  );
};

HoverBox.propTypes = {
  bottomBoundary: PropTypes.any,
  json: PropTypes.any,
  leftBoundary: PropTypes.any,
  rightBoundary: PropTypes.any,
  topBoundary: PropTypes.any,
};
